/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Top_LevelInputs */

const vi_sidebar_layout_top_level = /** @type {(inputs: Sidebar_Layout_Top_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu cấp 1`)
};

/**

* @param {Sidebar_Layout_Top_LevelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_top_level = /** @type {((inputs?: Sidebar_Layout_Top_LevelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Top_LevelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_top_level(inputs)
});